@if (printView) {
    <div class="objectives-container-print-view">
        <div class="objective-content">
            <div class="objective-label">
                <span class="vismaicon vismaicon-reminder vismaicon-no-hover"></span>
                <h3 translate="LATE_ARRIVALS"></h3>
            </div>
            <div class="objective-value">
        <span
            [innerHTML]="
                    'PROGRESS_TASK_TIME_WINDOW' | translate: { value1: lateTime.hours, value2: lateTime.minutes }
                "
        ></span>
            </div>
        </div>
        @if (visitHistoryObjectiveEnabled) {
            <div class="objective-content">
                <div class="objective-label">
                    <span class="vismaicon vismaicon-users vismaicon-no-hover"></span>
                    <h3 translate="VISIT_CONTINUITY"></h3>
                </div>
                <div class="objective-value">
                    <span [innerHTML]="'PROGRESS_VISIT_CONTINUITY' | translate: { value: employeesCount.count }"></span>
                </div>
            </div>
        }
        <div class="objective-content">
            <div class="objective-label">
                <span class="vismaicon icon-car"></span>
                <h3 translate="TRAVEL_TIME"></h3>
            </div>
            <div class="objective-value">
        <span
            [innerHTML]="
                    'PROGRESS_TRAVEL_TIME' | translate: { value1: travelTime.hours, value2: travelTime.minutes }
                "
        ></span>
            </div>
        </div>
        <div class="objective-content">
            <div class="objective-label">
                <span class="vismaicon icon-task-overview"></span>
                <h3 translate="TASK_TIME"></h3>
            </div>
            <div class="objective-value">
        <span
            [innerHTML]="'TASK_TIME_VALUE' | translate: { value1: taskTime.hours, value2: taskTime.minutes }"
        ></span>
            </div>
        </div>
    </div>
}

@if (!printView) {
    <div class="objectives-container" [ngClass]="{ 'white-background': whiteBackground }">
        @if (showAllocatedTask) {
            <app-tooltip
                class="objective-icon"
                appCustomPopover
                placement="top"
                popoverText="TOTAL_NUMBER_OF_ALLOCATED_TASKS"
                [adaptPlacement]="true"
            >
                <ng-container icon>
                    @if (showAllocatedTask) {
                        <div class="objective-content">
                            <div class="h-100 route-planning-allocated-tasks">
                                <div class="objective-label route-planning-allocated-tasks-name">
                                    <span translate="ALLOCATED_VISITS"></span>
                                </div>
                                <div
                                    class="objective-value"
                                    [@fadeInOnEnter]
                                >
                                    <span>{{ routesLength }}</span> &nbsp;{{ 'VISITS' | translate }}&nbsp;
                                </div>
                            </div>
                        </div>
                    }
                </ng-container>
            </app-tooltip>
        }
        @if (showPatientTime) {
            <app-tooltip
                class="objective-icon"
                appCustomPopover
                placement="top"
                popoverText="TOTAL_TASK_TIME"
                [adaptPlacement]="true"
            >
                <ng-container icon>
                    <div class="objective-content">
                        <div class="h-100 route-planning-allocated-tasks">
                            <div class="objective-label route-planning-allocated-tasks-name">
                                <span translate="TOTAL_TASK_TIME"></span>
                            </div>
                            @if (patientTime != null) {
                                <div
                                    class="objective-value"
                                    [ngClass]="{ increase: patientTime.increase, decrease: patientTime.decrease }"
                                    [@fadeInOnEnter]
                                >
                                    <span>{{ patientTime.hours }}</span> {{ 'HOURS_SHORT' | translate }}&nbsp;
                                    <span>{{ patientTime.minutes }}</span> {{ 'MINUTES_SHORT' | translate }}&nbsp;
                                </div>
                            }
                        </div>
                    </div>
                </ng-container>
            </app-tooltip>
        }
        @if (timeWindowObjectiveEnabled) {
            <app-tooltip
                class="objective-icon"
                appCustomPopover
                popoverText="LATE_ARRIVALS_OBJECTIVE_INFO"
                placement="top"
                [adaptPlacement]="true"
            >
                <ng-container icon>
                    @if (timeWindowObjectiveEnabled) {
                        <div class="objective-content">
                            <div class="h-100">
                                <div class="objective-label">
                                    <span translate="LATE_ARRIVALS"></span>
                                </div>
                                @if (lateTime != null) {
                                    <div
                                        class="objective-value"
                                        [ngClass]="{ increase: lateTime.increase, decrease: lateTime.decrease }"
                                        [@fadeInOnEnter]
                                    >
                                        <span>{{ lateTime.hours }}</span> {{ 'HOURS_SHORT' | translate }}&nbsp;
                                        <span>{{ lateTime.minutes }}</span> {{ 'MINUTES_SHORT' | translate }}&nbsp;
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </ng-container>
            </app-tooltip>
        }
        @if (travelTimeObjectiveEnabled) {
            <app-tooltip
                class="objective-icon"
                appCustomPopover
                popoverText="TRAVEL_TIME_OBJECTIVE_INFO"
                placement="top"
                [adaptPlacement]="true"
            >
                <ng-container icon>
                    @if (travelTimeObjectiveEnabled) {
                        <div class="objective-content">
                            <div class="h-100">
                                <div class="objective-label">
                                    <span translate="TRAVEL_TIME"></span>
                                </div>
                                @if (travelTime != null) {
                                    <div
                                        class="objective-value"
                                        [ngClass]="{ increase: travelTime.increase, decrease: travelTime.decrease }"
                                        [@fadeInOnEnter]
                                    >
                                        <span>{{ travelTime.hours }}</span> {{ 'HOURS_SHORT' | translate }}&nbsp;
                                        <span>{{ travelTime.minutes }}</span> {{ 'MINUTES_SHORT' | translate }}&nbsp;
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </ng-container>
            </app-tooltip>
        }
        @if (visitHistoryObjectiveEnabled) {
            <div class="visit-objective-container">
                <app-tooltip
                    class="objective-icon"
                    appCustomPopover
                    popoverText="VISIT_CONTINUITY_OBJECTIVE_INFO"
                    [textParam]="numberOfTasksWithoutMainResponsibles"
                    placement="top"
                    [adaptPlacement]="true"
                    [adaptivePosition]="true"
                >
                    <ng-container icon>
                        @if (visitHistoryObjectiveEnabled) {
                            <div class="objective-content">
                                <div class="h-100">
                                    <div class="objective-label">
                                        <span translate="VISIT_CONTINUITY"></span>
                                    </div>
                                    @if (employeesCount != null) {
                                        <div
                                            class="objective-value"
                                            [ngClass]="{ increase: employeesCount.increase, decrease: employeesCount.decrease }"
                                            [@fadeInOnEnter]
                                        >
                                            <span>{{ employeesCount.count }}</span>
                                            &nbsp;{{ 'X_NEW_VISITS' | translate }}
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </ng-container>
                </app-tooltip>
                @if (overMaxEmployeesCount?.count) {
                    <span class="separator"></span>
                    <app-tooltip appCustomPopover popoverText="ABOVE_MAX_VISIT_CONTINUITY_OBJECTIVE_INFO"
                                 placement="top">
                        <ng-container icon>
                            <div class="objective-content">
                                <div class="h-100">
                                    <div class="objective-label">
                                        <span translate="ABOVE_MAX"></span>
                                    </div>
                                    <div
                                        class="objective-value"
                                        [ngClass]="{
                                    increase: overMaxEmployeesCount?.increase,
                                    decrease: overMaxEmployeesCount?.decrease
                                }"
                                        [@fadeInOnEnter]
                                    >
                                        <span>{{ overMaxEmployeesCount?.count }}</span> &nbsp;{{ 'VISITS' | translate }}
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </app-tooltip>
                }
            </div>
        }
        @if (overqualificationObjectiveEnabled) {
            <app-tooltip
                class="objective-icon"
                appCustomPopover
                popoverText="OVERQUALIFICATION_OBJECTIVE_INFO"
                placement="top"
                [adaptPlacement]="true"
            >
                <ng-container icon>
                    @if (overqualificationObjectiveEnabled) {
                        <div class="objective-content">
                            <div class="h-100">
                                <div class="objective-label">
                                    <span translate="OVERQUALIFICATION"></span>
                                </div>
                                @if (overqualificationNumberOfTasksCount != null) {
                                    <div
                                        class="objective-value"
                                        [ngClass]="{
                            increase: overqualificationNumberOfTasksCount.increase,
                            decrease: overqualificationNumberOfTasksCount.decrease
                        }"
                                        [@fadeInOnEnter]
                                    >
                                        <span>{{ overqualificationNumberOfTasksCount.count }}</span>
                                        &nbsp;{{ 'PROGRESS_OVERQUALIFICATION' | translate }}
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </ng-container>
            </app-tooltip>
        }
        @if (showUnallocatedTasks) {
            <app-tooltip
                class="objective-icon"
                position="top"
                [adaptivePosition]="true"
            >
                <ng-container icon>
                    @if (showUnallocatedTasks) {
                        <div class="objective-content">
                            <div class="h-100">
                                <div class="objective-label">
                                    <span translate="UNALLOCATED_EMPLOYEE_TASKS"></span>
                                </div>
                                @if (unallocatedTasks != null) {
                                    <div
                                        class="objective-value"
                                        [ngClass]="{ increase: unallocatedTasks.increase, decrease: unallocatedTasks.decrease }"
                                        [@fadeInOnEnter]
                                    >
                                        <span>{{ unallocatedTasks.count }}</span>
                                        &nbsp;{{ 'PROGRESS_UNALLOCATED' | translate }}
                                    </div>
                                }
                            </div>
                            <div class="h-100">
                                <div class="objective-label">
                                    <span translate="UNALLOCATED_PATIENT_TASKS"></span>
                                </div>
                                @if (unallocatedTasksPatients != null) {
                                    <div
                                        class="objective-value"
                                        [ngClass]="{ increase: unallocatedTasksPatients.increase, decrease: unallocatedTasksPatients.decrease }"
                                        [@fadeInOnEnter]
                                    >
                                        <span>{{ unallocatedTasksPatients.count }}</span>
                                        &nbsp;{{ 'PROGRESS_UNALLOCATED' | translate }}
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </ng-container>
            </app-tooltip>
        }
        @if (showTaskTime) {
            <app-tooltip
                class="objective-icon"
                appCustomPopover
                popoverText="TASK_TIME_OBJECTIVE_INFO"
                placement="top"
                [adaptPlacement]="true"
            >
                <ng-container icon>
                        <div class="objective-content">
                            <div class="h-100">
                                <div class="objective-label">
                                    <span translate="TASK_TIME"></span>
                                </div>
                                @if (taskTime != null) {
                                    <div
                                        class="objective-value"
                                        [ngClass]="{ increase: taskTime.increase, decrease: taskTime.decrease }"
                                        [@fadeInOnEnter]
                                    >
                                        <span>{{ taskTime.hours }}</span> {{ 'HOURS_SHORT' | translate }}&nbsp;
                                        <span>{{ taskTime.minutes }}</span> {{ 'MINUTES_SHORT' | translate }}&nbsp;
                                    </div>
                                }
                            </div>
                        </div>
                </ng-container>
            </app-tooltip>
        }
        @if (showTasksFromDifferentDepartment && rosterInInstance) {
            <app-tooltip
                class="objective-icon"
                appCustomPopover
                popoverText="DIFFERENT_ROSTER_DEPARTMENT_OBJECTIVE_INFO"
                placement="top"
                [adaptPlacement]="true"
            >
                <ng-container icon>
                    @if (showTasksFromDifferentDepartment) {
                        <div class="objective-content">
                            <div class="h-100">
                                <div class="objective-label">
                                    <span translate="DIFFERENT_ROSTER_DEPARTMENT"></span>
                                </div>
                                @if (tasksFromDifferentDepartmentCount != null) {
                                    <div
                                        class="objective-value"
                                        [ngClass]="{ increase: tasksFromDifferentDepartmentCount.increase, decrease: tasksFromDifferentDepartmentCount.decrease }"
                                        [@fadeInOnEnter]
                                    >
                                        <span>{{ tasksFromDifferentDepartmentCount.count }}</span>
                                        &nbsp;{{ 'PROGRESS_DIFFERENT_DEPARTMENT' | translate }}
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </ng-container>
            </app-tooltip>
        }
    </div>
}
